import React, { useMemo } from "react";
import { useLocation } from "react-router";
import { NoticeDetailForm } from "../../components/organisms/Notice/Detail";

const NoticeDetail: React.FC = () => {
  const { pathname } = useLocation();

  const id = useMemo(() => {
    const splitPathname = pathname.split("/");
    return pathname.split("/")[splitPathname.length - 1];
  }, [pathname]);

  return <>{id && <NoticeDetailForm id={+id} />}</>;
};

export default NoticeDetail;
